var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size=24, type=attention"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0932 4.73379C11.5923 3.75741 12.4066 3.7534 12.9076 4.73379L19.7977 18.2247C20.2967 19.2011 19.8412 20 18.7754 20H5.22544C4.15963 20 3.70216 19.2051 4.20315 18.2247L11.0932 4.73379ZM11.3165 14.4977C11.4979 14.6857 11.7439 14.7913 12.0004 14.7913C12.2569 14.7913 12.5029 14.6857 12.6843 14.4977C12.8657 14.3097 12.9676 14.0547 12.9676 13.7889V8.77664C12.9676 8.51078 12.8657 8.2558 12.6843 8.06781C12.5029 7.87981 12.2569 7.7742 12.0004 7.7742C11.7439 7.7742 11.4979 7.87981 11.3165 8.06781C11.1352 8.2558 11.0333 8.51078 11.0333 8.77664V13.7889C11.0333 14.0547 11.1352 14.3097 11.3165 14.4977ZM11.3165 17.505C11.4979 17.693 11.7439 17.7986 12.0004 17.7986C12.2569 17.7986 12.5029 17.693 12.6843 17.505C12.8657 17.317 12.9676 17.0621 12.9676 16.7962C12.9676 16.5303 12.8657 16.2753 12.6843 16.0874C12.5029 15.8994 12.2569 15.7937 12.0004 15.7937C11.7439 15.7937 11.4979 15.8994 11.3165 16.0874C11.1352 16.2753 11.0333 16.5303 11.0333 16.7962C11.0333 17.0621 11.1352 17.317 11.3165 17.505Z",
    fill: "#E67D1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.245e3c8166dc181f7ee6bdf5bdd3056d.svg";
export { ForwardRef as ReactComponent };